import { Button } from 'react-bootstrap';
import { FaPause, FaPlay } from 'react-icons/fa6';
import { joinClasses } from 'utils/componentStyles/style.utils';

const WeatherMapPlaybackButton = ({
  isPlaying,
  onToggle,
  disabled = false,
  playLabel,
  pauseLabel,
  showText = false,
  className,
}) => {
  const accessibleLabel = isPlaying ? pauseLabel : playLabel;

  return (
    <Button
      variant="primary"
      size="sm"
      className={joinClasses(
        'd-inline-flex flex-shrink-0 align-items-center justify-content-center gap-2',
        className,
      )}
      onClick={onToggle}
      disabled={disabled}
      aria-label={accessibleLabel}
    >
      {isPlaying ? <FaPause /> : <FaPlay />}
      {showText && <span>{isPlaying ? 'Pause' : 'Play'}</span>}
    </Button>
  );
};

export default WeatherMapPlaybackButton;
